module.exports = __webpack_public_path__ + "img/stancija-cabrunici-web.e9127f1b.png";